module.exports = __webpack_public_path__ + "img/strength-4.e6d346aa.png";